import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { errText } from "@/lib/aadhaar";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const startGoogle = () => {
  const back = window.location.origin + window.location.pathname + window.location.search;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(back)}`;
};

const GoogleMark = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export const GoogleButton = ({ label }) => (
  <button type="button" onClick={startGoogle} data-testid="student-google-btn"
    className="w-full h-11 rounded-full border border-slate-300 bg-white text-sm font-bold text-[#0A192F] inline-flex items-center justify-center gap-2.5 hover:bg-slate-50 hover:border-slate-400 transition-colors">
    <GoogleMark />{label}
  </button>
);

// Handles the return from Google (#session_id=...) once; onDone gets the same reply as the password sign-in.
export const useGoogleReturn = (onDone, onError) => {
  const loc = useLocation();
  const nav = useNavigate();
  const done = useRef(false);
  const sid = loc.hash.match(/session_id=([^&]+)/)?.[1];
  const [pending, setPending] = useState(Boolean(sid));
  useEffect(() => {
    if (!sid || done.current) return;
    done.current = true;
    setPending(true);
    nav(loc.pathname + loc.search, { replace: true });
    api.post("/auth/google", { session_id: decodeURIComponent(sid) })
      .then(({ data }) => onDone(data))
      .catch((e) => onError(errText(e.response?.data?.detail, "Google sign-in failed. Please try again.")))
      .finally(() => setPending(false));
  }, [sid]); // eslint-disable-line react-hooks/exhaustive-deps
  return pending;
};
